import TransitionFadeIn from './TransitionFadeIn';

export default TransitionFadeIn;
